import React from "react";

const NoResponse = ({ setNoresponse }) => {
  console.log(window.location.pathname);
  return (
    <>
      <div className=" successful_preview_transprant_body ">
        <div className=" p-2 successful_preview_container shadow">
          {/* <img src="/images/Ellipse 208.svg" alt="" /> */}
          <img className="prereadLoader" src="/images/alert.svg" alt="" />
          <span className=" mb-4 mt-2 successfully_message">
            No content found with this filter setting.
          </span>
          <button
            className="successfull_okay_btn"
            onClick={() => {
              setNoresponse(false);
              if(window.location.pathname !== "/PublishedHomework"){
                window.location.reload();
                localStorage.setItem('buttons',"Published");
              }
            }}
          >
            Okay
          </button>
        </div>
      </div>
    </>
  );
};

export default NoResponse;
